import React, { Component } from "react";
import JSZip from "jszip";
import Button from "../../CustomButtons/Button.jsx";

class DownloadResults extends Component {
  constructor(props) {
    super(props);
    this.handleDownload = this.handleDownload.bind(this);
  }

  handleDownload() {
    const { rawText, rawJson, forms, items, summary, tables } = this.props;

    let text = "";
    if (Array.isArray(rawText)) {
      rawText.forEach((row) => {
        if (typeof row === "object" && row !== null && row.text) {
          text += row.text + "\n"; 
        } else {
          text += row + "\n";
        }
      });
    }

    const zip = new JSZip();

    zip.file("raw_text.txt", text || "No text available");
    zip.file("raw_json.json", JSON.stringify(rawJson || {}, null, 2));

    if (forms) {
      zip.file("key_pair.csv", forms);
    }

    if (items) {
      zip.file("receipt_items.csv", items);
    }

    if (summary) {
      zip.file("receipt_summary.csv", summary);
    }

    if (tables) {
      zip.file("table.csv", tables);
    }

    // Format date for filename
    const d = new Date();
    const date =
      ("0" + d.getDate()).slice(-2) +
      "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "-" +
      d.getFullYear();

    zip.generateAsync({ type: "blob" }).then((content) => {
        const url = window.URL.createObjectURL(content);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${date}-textract-results.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      (err) => {
        console.error("Zip generation failed:", err);
      }
    );
  }

  render() {
    return (
      <div className="download-btn">
        <Button color="custom"  id="download-now" onClick={this.handleDownload}>
            Download
        </Button>
      </div>
    );
  }
}

export default DownloadResults;
